import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { FacilityService } from 'src/app/cms/facility/facility.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-facility',
  templateUrl: './facility.component.html',
  styleUrls: ['./facility.component.scss']
})
export class FacilityComponent implements OnInit {
  private facility$: Observable<any>
  facility: any
  imageBaseUrl = environment.resourceUrl+'/image/'

  constructor(
    private fs: FacilityService,
  ) {

  }

  ngOnInit() {
    this.facility$ = this.fs.getFacility()
    this.facility$.subscribe(data => {
      this.facility = data
    })
  }
}
